import SurveyBannerContainer from "./SurveyBannerContainer";
export default SurveyBannerContainer;
